module.exports = __webpack_public_path__ + "img/flag-supply-red.a538e17b.svg";